export const workspace = {
  routes: [
    {
      path: "/workspace/library/measure",
      component: () => import("../workspace-library-measure-view"),
    },
  ],
};

export const management = {
  routes: [],
};
